import type { TGooglePlaceSuggestion } from "@/api/google-maps/search/google-search.type.ts";
import type { IAddressAdaptable, IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { IAddressVisitor, TAddressVisitorOutput } from "@/domains/address/address-visitor.ts";
import type { IExternalAddress } from "@/domains/address/external-address.ts";

import { cloneDeep } from "es-toolkit";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";

export class GoogleAddress implements IExternalAddress<TGooglePlaceSuggestion>, IAddressAdaptable<GoogleAddress> {
  private readonly _address: TGooglePlaceSuggestion;

  constructor(address: TGooglePlaceSuggestion) {
    this._address = cloneDeep(address);
  }

  accept<V extends IAddressVisitor>(visitor: V): TAddressVisitorOutput<V> {
    return visitor.visitGoogle(this) as TAddressVisitorOutput<V>;
  }

  adapt<OUTPUT>(adapter: IAddressAdapter<GoogleAddress, OUTPUT>): OUTPUT {
    return adapter.adapt(this);
  }

  getProvider(): EAddressProvider {
    return EAddressProvider.GOOGLE;
  }

  getRaw(): TGooglePlaceSuggestion {
    return cloneDeep(this._address);
  }
}
